import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { ClubEditorPage } from '@sorare/gameplay/src/pages/profile/ClubEditor';

const EditPage = () => <ClubEditorPage sport={Sport.BASEBALL} />;

export default EditPage;
